import { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { UserContext } from '../../context/UserContext';
import api from "../Api/Api";
import Navigation from "../Navbar";
import Spinner from "../../Components/Spinner";
import { Button, Col, Row, Tab, Table, Tabs } from "react-bootstrap";
import { FaWhatsapp } from "react-icons/fa";
import { MdAddAPhoto } from "react-icons/md";

const Itensaprovacao = () => {
    const location = useLocation();
    const orcamento = location.state;
    const {user} = useContext(UserContext)
    const navigate = useNavigate(); 
    const [ShowLoading, setShowLoading] = useState(false) 
    const [placa, setPlaca] = useState('')
    const [num, setNum] = useState("");
    const [name, setName] = useState("");    
    const [msg, setMsg] = useState(""); 
    const [showitens, setShowitens] = useState(false)
    interface Itens {
        id: number;
        produto: string;
        prodescricao: string;
        quantidade: number;
        preco: number;
        pco_venda: number;
        pco_avista: number;
        promocao: number;
        autoriza: string;
      }     
    //const itens: Itens[] = [];
    const [_pro, set_Pro] = useState<Itens[]>([]);    
    const handlingautoriza = () => {  
        setShowLoading(true)
        setShowitens(true) 
        api.get('Itensaprovacao?filial='+user.filial+'&consulta='+orcamento)
        .then(response => {  
            if (response.data.Orcamento.length > 0 ){  
                    setPlaca(response.data.Orcamento[0]['placa']); 
                    setNum('55'+response.data.Orcamento[0]['ddd']+response.data.Orcamento[0]['fone']);
                    setName(response.data.Orcamento[0]['nome']);
                    // setInfoveuculo('Placa: ' + response.data.Orcamento[0]['placa'] ); //+ ' Modelo: ' + response.data.Dadoscliente[0]['modelo'] + ' Cor: ' + response.data.Dadoscliente[0]['cor'])               
                    if (_pro.length < response.data.Orcamento.length){
                        for (let i = 0; i < response.data.Orcamento.length; i++) {
                            //itens.push({ id: Number(response.data.Orcamento[i]['id']), produto: response.data.Orcamento[i]['produto'], prodescricao: response.data.Orcamento[i]['descricao'], quantidade: response.data.Orcamento[i]['quantidade'], pco_venda: response.data.Orcamento[i]['vlunitario'] }); pco_venda: data[rowsSelected[i]]['pco_venda'],pco_avista: data[rowsSelected[i]]['pco_avista'], promocao: data[rowsSelected[i]]['promocao'] 
                            _pro.push({ id: Number(response.data.Orcamento[i]['id']), produto: response.data.Orcamento[i]['produto'], prodescricao: response.data.Orcamento[i]['descricao'], quantidade: response.data.Orcamento[i]['quantidade'],preco: response.data.Orcamento[i]['vlunitario'], pco_venda: response.data.Orcamento[i]['vlunitario'],pco_avista: 0, promocao: 0, autoriza: response.data.Orcamento[i]['autoriza']}) 
                        } 
                    } 
                    setShowLoading(false)
                    set_Pro(_pro)                  
            }else{
                setShowLoading(false) 
                alert("Não foram encontrados itens aptos para aprovação!")               
            }                                   
        });                
    }  
    const gofoto= (Orcamento: string,Produto: string) => {
        let datastate = {
            orcamento: Orcamento,
            produto: Produto
        }
        return datastate
    } 
    const enviacliente = () => {
        let msg = `https://carcenterpneusbrasil.com/aprovacao?orcamento=${orcamento}&filial=${user.filial}`
        const win = window.open(`https://wa.me/${num}?text=Olá,%20${name},%20aqui%20é%20o%20consultor%20${user.name}%20da%20Pneus%20Brasil.%20Seu%20veículo%20precisou%20de%20novos%20itens,%20abrindo%20o%20link%20aseguir%20será%20possível%20visualizar%20e%20aprovar%20estes%20itens%20${msg}`, '_blank');
        console.log(num)

    }
    useEffect(() => {
        if(!showitens) { 
            // setNum("")
            handlingautoriza()
        }
                       
    })       
    return(
        <div>
            <Navigation />
            <div className="container-lg">
                <label className="d-flex justify-content-center fs-3 text-primary">Orçamento: {orcamento}</label>
                <label className="d-flex justify-content-center fs-3 text-primary">Itens para aprovação</label>
                <div className="d-flex justify-content-center flex-column flex-md-row">
                    <div className='mt-2'>    
                        <Row>
                            <Col className="mt-lg-3 mt-sm-3">
                                <Tabs
                                defaultActiveKey="latest"
                                transition={false}
                                id="collum-3"
                                className="mb-3"
                                justify 
                                >
                                    <Tab eventKey="latest" title="Itens" >
                                        <Table striped borderless hover responsive>
                                            <tbody>
                                                <tr className="fw-bold">
                                                <td>Item</td>
                                                <td>Produto</td>
                                                <td>Descrição</td>
                                                <td>Quantidade</td>
                                                <td>Ações</td>
                                                </tr>  
                                                {_pro.map((iten: any,i: any) => (
                                                    <tr key={i} id={i} className={i}>
                                                    <td>{iten.id}</td>    
                                                    <td>{iten.produto}</td>
                                                    {iten.autoriza === 'S' ? 
                                                        (<td className={'text-danger'} >{iten.prodescricao}</td>) :
                                                        <td>{iten.prodescricao}</td>
                                                    }
                                                    <td className="fw-bold" > {iten.quantidade}</td>
                                                    <td> 
                                                        <abbr title='Foto'>
                                                            <Button className="" size="sm" variant="outline-success " >
                                                            <Link to='/Fotopecas' state={gofoto(orcamento,iten.produto)}>Foto <MdAddAPhoto  /></Link>                                                  
                                                            </Button>                                                   
                                                        </abbr>                                                                  
                                                    </td>
                                                    </tr>
                                                    // onClick={(e) => {handlingQuantidade(e,i)}}
                                                ))}
                                            </tbody>
                                        </Table>                                            
                                    </Tab>
                                </Tabs>                    
                            </Col>                        
                        </Row>                     
                    </div>
                </div>
                <div className="d-flex justify-content-center">
                <button className="mt-4 me-4 btn btn-success" onClick={() => enviacliente()}><Link className="alert-link" to='/Itensaprovacao' state={orcamento}> Enviar<FaWhatsapp className="ms-2" size={50} /></Link></button>
                </div>
            </div>
            <Spinner isLoading={ShowLoading} />
        </div>
    )
}

export default Itensaprovacao;
